module.exports = __webpack_public_path__ + "media/images/front/life_style/2-50db4399f456d218150260563ca2eb0e.jpg";